import axios from 'axios';
import environment from "@/environment";

const httpClient = axios.create({
    withCredentials: true, // КРИТИЧНО: позволяет передавать httpOnly куки
});

let isRefreshing = false;
let failedQueue = [];

// Функция для обработки очереди задержанных запросов
const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};

httpClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        // Если получили 401 и это не повторный запрос и не запрос на сам логин/рефреш
        if (error.response?.status === 401 && !originalRequest._retry && !error.config?.url.includes("auth")) {

            if (isRefreshing) {
                // Если рефреш уже идет, кладем запрос в "зал ожидания"
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then(() => httpClient(originalRequest))
                    .catch((err) => Promise.reject(err));
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {
                // Вызываем эндпоинт обновления.
                // Бэкенд проверит Refresh-куку и пришлет новые Set-Cookie
                await httpClient.post(environment.appConfig.baseApiUrl + 'auth/refresh');
                processQueue(null);
                return httpClient(originalRequest); // Повторяем исходный запрос
            } catch (refreshError) {
                processQueue(refreshError, null);

                // Settings остаются доступны анонимному пользователю. После
                // неудачного refresh backend удаляет cookie, поэтому повторный
                // запрос загрузит публичные настройки без повторной авторизации.
                if (originalRequest.url.includes('/settings')) {
                    return httpClient(originalRequest);
                }

                // Тут "вайб" заканчивается: если рефреш сдох, кидаем на логин
                // Можно использовать роутер или стейт-менеджер (Pinia)
                window.location.href = '/#/login';
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error);
    }
);

export default httpClient;
